import React, { useEffect, useState } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
import { Calendar, MapPin, Clock, Users, DollarSign, FileText, Mail } from 'lucide-react';
export function MidwestCup2026Page() {
  const [selectedPackage, setSelectedPackage] = useState<string>('');
  const [selectedEvent, setSelectedEvent] = useState<string>('');
  useEffect(() => {
    document.title = "Midwest Cup 2026 | Walker's Martial Arts | Bloomington, Illinois";
  }, []);
  const registrationPackages = [{
    id: '1-event',
    name: '1 EVENT',
    price: 65.0,
    hasOptions: true,
    options: ['FORMS', 'SPARRING', 'BREAKING'],
    helperText: 'Choose one event.'
  }, {
    id: '2-events',
    name: '2 EVENTS',
    price: 75.0,
    hasOptions: true,
    options: ['FORMS / SPARRING', 'FORMS / BREAKING', 'SPARRING / BREAKING'],
    helperText: 'Choose two events.'
  }, {
    id: 'all-events',
    name: 'ALL EVENTS',
    price: 85.0,
    hasOptions: false,
    options: [],
    helperText: 'Includes all events.'
  }];
  return <div className="bg-black min-h-screen" data-id="element-704">
      <Navigation data-id="element-705" />

      {/* Hero Section */}
      <div className="relative pt-32 pb-20 overflow-hidden" data-id="element-706">
        <div className="absolute inset-0 z-0" data-id="element-707">
          <div className="absolute inset-0 bg-gradient-to-b from-black via-black/90 to-black" data-id="element-708" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-709">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-center" data-id="element-710">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#00D4FF]/10 border border-[#00D4FF]/30 text-[#00D4FF] text-sm font-semibold mb-6" data-id="element-711">
              <span className="w-2 h-2 rounded-full bg-[#00D4FF] animate-pulse" data-id="element-712" />
              Registration Now Open
            </div>
            <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-4" data-id="element-713">
              MIDWEST CUP <span className="text-[#00D4FF]" data-id="element-714">2026</span>
            </h1>
            <p className="text-xl text-gray-400 mb-6" data-id="element-715">WALKER'S MARTIAL ARTS</p>
            <p className="text-lg text-gray-300 max-w-3xl mx-auto" data-id="element-716">
              Registration has opened for the 2026 Midwest Cup Taekwondo
              tournament hosted by Walker's Martial Arts.
            </p>
          </motion.div>
        </div>
      </div>

      {/* Important Info Section */}
      <section className="py-16 bg-[#0a0a0a]" data-id="element-717">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-718">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-[#1a1a1a] p-8 rounded-2xl border border-gray-800" data-id="element-719">
            <h2 className="text-2xl font-bold text-white mb-6" data-id="element-720">
              Important Information
            </h2>
            <ul className="space-y-4 mb-8" data-id="element-721">
              <li className="flex items-start gap-3 text-gray-300" data-id="element-722">
                <div className="w-2 h-2 bg-[#00D4FF] rounded-full mt-2 shrink-0" data-id="element-723" />
                <span data-id="element-724">
                  All styles welcome! Forms Breaking & Olympic Sparring Ages 3 &
                  up
                </span>
              </li>
              <li className="flex items-start gap-3 text-gray-300" data-id="element-725">
                <div className="w-2 h-2 bg-[#00D4FF] rounded-full mt-2 shrink-0" data-id="element-726" />
                <span data-id="element-727">Spectator fees only $10.00 (age 4 & under free)</span>
              </li>
              <li className="flex items-start gap-3 text-gray-300" data-id="element-728">
                <div className="w-2 h-2 bg-[#00D4FF] rounded-full mt-2 shrink-0" data-id="element-729" />
                <span data-id="element-730">ALL payments must be made by June 13 2026</span>
              </li>
              <li className="flex items-start gap-3 text-gray-300" data-id="element-731">
                <div className="w-2 h-2 bg-[#00D4FF] rounded-full mt-2 shrink-0" data-id="element-732" />
                <span data-id="element-733">No refunds after June 13 2026</span>
              </li>
            </ul>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-734">
              <a href="#" className="flex items-center justify-center gap-2 bg-[#00D4FF] text-black px-6 py-3 rounded font-bold uppercase tracking-wider hover:bg-[#33ddff] transition-colors" data-id="element-735">
                <FileText className="w-5 h-5" data-id="element-736" />
                Tournament Packet Here
              </a>
              <a href="/contact" className="flex items-center justify-center gap-2 border border-[#00D4FF] text-[#00D4FF] px-6 py-3 rounded font-bold uppercase tracking-wider hover:bg-[#00D4FF]/10 transition-colors" data-id="element-737">
                <Mail className="w-5 h-5" data-id="element-738" />
                Contact Us for Sponsorship Info!
              </a>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Event Details Section */}
      <section className="py-16 bg-black" data-id="element-739">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-740">
          <h2 className="text-3xl font-bold text-white mb-12 text-center" data-id="element-741">
            Event Details
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-742">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-[#1a1a1a] p-6 rounded-xl border border-gray-800" data-id="element-743">
              <div className="flex items-center gap-3 mb-4" data-id="element-744">
                <Calendar className="w-6 h-6 text-[#00D4FF]" data-id="element-745" />
                <h3 className="text-xl font-bold text-white" data-id="element-746">Date</h3>
              </div>
              <p className="text-gray-300 text-lg" data-id="element-747">July 18, 2026</p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-[#1a1a1a] p-6 rounded-xl border border-gray-800" data-id="element-748">
              <div className="flex items-center gap-3 mb-4" data-id="element-749">
                <MapPin className="w-6 h-6 text-[#00D4FF]" data-id="element-750" />
                <h3 className="text-xl font-bold text-white" data-id="element-751">Venue</h3>
              </div>
              <p className="text-gray-300 text-lg" data-id="element-752">
                Illinois Wesleyan University
              </p>
              <p className="text-gray-400 text-sm mt-1" data-id="element-753">
                302 E. Emerson Street, Bloomington, Illinois
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="bg-[#1a1a1a] p-6 rounded-xl border border-gray-800" data-id="element-754">
              <div className="flex items-center gap-3 mb-4" data-id="element-755">
                <Clock className="w-6 h-6 text-[#00D4FF]" data-id="element-756" />
                <h3 className="text-xl font-bold text-white" data-id="element-757">Schedule</h3>
              </div>
              <ul className="space-y-2 text-gray-300" data-id="element-758">
                <li data-id="element-759">Doors Open: 8:00 a.m.</li>
                <li data-id="element-760">Blackbelt & Judges Meeting: 9:30 a.m.</li>
                <li data-id="element-761">Opening Ceremony: 10:00 a.m.</li>
                <li data-id="element-762">Tournament Starts: 10:30 a.m.</li>
              </ul>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="bg-[#1a1a1a] p-6 rounded-xl border border-gray-800" data-id="element-763">
              <div className="flex items-center gap-3 mb-4" data-id="element-764">
                <Users className="w-6 h-6 text-[#00D4FF]" data-id="element-765" />
                <h3 className="text-xl font-bold text-white" data-id="element-766">
                  Who Can Compete
                </h3>
              </div>
              <p className="text-gray-300" data-id="element-767">
                All styles welcome! Open to competitors ages 3 and up.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Registration Packages Section */}
      <section className="py-16 bg-[#0a0a0a]" data-id="element-768">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-769">
          <h2 className="text-3xl font-bold text-white mb-4 text-center" data-id="element-770">
            Tournament Registration
          </h2>
          <p className="text-gray-400 text-center mb-12" data-id="element-771">
            Choose your registration package below
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-772">
            {registrationPackages.map((pkg, index) => <motion.div key={pkg.id} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-[#1a1a1a] p-8 rounded-2xl border border-gray-800 hover:border-[#00D4FF]/50 transition-all" data-id="element-773">
                <div className="text-center mb-6" data-id="element-774">
                  <h3 className="text-2xl font-bold text-white mb-2" data-id="element-775">
                    {pkg.name}
                  </h3>
                  <div className="flex items-center justify-center gap-1 mb-4" data-id="element-776">
                    <DollarSign className="w-8 h-8 text-[#00D4FF]" data-id="element-777" />
                    <span className="text-4xl font-bold text-white" data-id="element-778">
                      {pkg.price.toFixed(2)}
                    </span>
                  </div>
                  <p className="text-gray-400 text-sm" data-id="element-779">{pkg.helperText}</p>
                </div>

                {pkg.hasOptions && <div className="mb-6" data-id="element-780">
                    <label className="block text-sm font-medium text-gray-400 mb-3" data-id="element-781">
                      {pkg.id === '1-event' ? 'EVENT:' : 'EVENTS:'}
                    </label>
                    <select className="w-full px-4 py-3 rounded-lg border border-gray-700 bg-black text-white focus:ring-2 focus:ring-[#00D4FF] focus:border-transparent outline-none transition-all" value={selectedPackage === pkg.id ? selectedEvent : ''} onChange={e => {
                setSelectedPackage(pkg.id);
                setSelectedEvent(e.target.value);
              }} data-id="element-782">
                      <option value="" data-id="element-783">Select an option</option>
                      {pkg.options.map(option => <option key={option} value={option} data-id="element-784">
                          {option}
                        </option>)}
                    </select>
                  </div>}

                <a href="/contact" className="w-full bg-[#00D4FF] text-black py-3 rounded font-bold uppercase tracking-wider hover:bg-[#33ddff] transition-colors block text-center" data-id="element-785">
                  Register
                </a>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} className="mt-12 text-center" data-id="element-786">
            <p className="text-gray-400 text-sm" data-id="element-787">
              Registration closes June 13, 2026. No refunds after this date.
            </p>
          </motion.div>
        </div>
      </section>

      <Footer data-id="element-788" />
    </div>;
}